import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel } from "./motion";

const ARTICLES = [
  { tag: "Salary Guide", title: "Bengaluru Tech Salary Benchmarks 2026", read: "8 min read" },
  { tag: "Hiring Trends", title: "Why Contract Staffing Is Booming in India", read: "6 min read" },
  { tag: "Career Advice", title: "The 7 Questions Every Interviewer Will Ask", read: "5 min read" },
  { tag: "Career Advice", title: "From Executive to Leader: Making the Jump", read: "9 min read" },
];

export default function Resources() {
  return (
    <section id="resources" className="bg-[#F4F5F7] py-24 md:py-32 px-6 md:px-12 lg:px-24" data-testid="resources-section">
      <SectionLabel number="05" text="Career Resources" />
      <Reveal>
        <h2 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#0A1128] mb-16">
          Sharp reads for<br />sharp careers.
        </h2>
      </Reveal>

      <div>
        {ARTICLES.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.06}>
            <button
              className="group w-full border-t border-[#0A1128]/10 last:border-b py-8 md:py-10 grid grid-cols-12 gap-4 items-center text-left hover:bg-white transition-colors duration-300 px-2 md:px-6"
              data-testid={`resource-item-${i}`}
            >
              <span className="col-span-12 md:col-span-2 text-[10px] uppercase tracking-[0.25em] text-[#1D4ED8]">{a.tag}</span>
              <h3 className="col-span-12 md:col-span-8 font-display font-bold text-2xl md:text-3xl tracking-tight text-[#0A1128] group-hover:text-[#1D4ED8] transition-colors duration-300">
                {a.title}
              </h3>
              <span className="col-span-10 md:col-span-1 text-xs text-[#475569] uppercase tracking-[0.15em]">{a.read}</span>
              <span className="col-span-2 md:col-span-1 flex justify-end">
                <ArrowUpRight className="text-[#0A1128]/30 group-hover:text-[#1D4ED8] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" size={24} />
              </span>
            </button>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
